import { type Time } from '@internationalized/date';
import clsx from 'clsx';
import React from 'react';
import useNativeHourInput from './useNativeHourInput';

/**
 * NativeHourInput — variante táctil del `HourField`: un `<input type="time">` nativo que abre la rueda de hora
 * del sistema operativo (iOS/Android) en lugar del teclado en pantalla que invocan los segmentos de react-aria
 * (TAN-10405). Comparte las clases `date-picker-hour*` con la variante de escritorio.
 */

type NativeHourInputProps = {
  onChange: (time: Time | null) => void;
  value: Time | null;
};

function NativeHourInput({ onChange, value }: NativeHourInputProps): JSX.Element {
  const { inputRef, nativeValue, onNativeBlur, onNativeChange, shouldShowPlaceholder, t } = useNativeHourInput({ onChange, value });

  return (
    <label className="date-picker-hour">
      <span className="date-picker-hour__label">{t('common:Hour')}</span>
      <span className="date-picker-hour__native-wrapper">
        <input
          aria-label={t('common:Hour')}
          className={clsx('date-picker-hour__native-input', { 'date-picker-hour__native-input--empty': shouldShowPlaceholder })}
          onBlur={onNativeBlur}
          onChange={onNativeChange}
          ref={inputRef}
          type="time"
          value={nativeValue}
        />
        {shouldShowPlaceholder && (
          <span aria-hidden="true" className="date-picker-hour__native-placeholder">
            --:--
          </span>
        )}
      </span>
    </label>
  );
}

export default NativeHourInput;
